import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import CustomRadioButtonField from "./CustomRadioButtonField.js";
import { EMAIL_VALIDATOR } from "helpers/validators.js";
import { useCustomController } from "components/Reusable/Form/useCustomController.js";
import Tooltip from "../../../Elements/Tooltip/Tooltip.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import { useEffect } from "react";
import { useUser } from "contexts/userContext/userContext.js";

const Divider2 = () => {
  const { getTextByKey } = useContent();

  return (
    <div className="Divider-within-the-form">
      {getTextByKey("profilesettings-notifications-title")}
    </div>
  );
};
const Divider3 = () => {
  const { getTextByKey } = useContent();

  return (
    <div className="Divider-within-the-form">
      {getTextByKey("profilesettings-general-settings-title")}
    </div>
  );
};

const Divider4 = () => {
  const { getTextByKey } = useContent();

  return (
    <div className="Divider-within-the-form">
      {getTextByKey("profile-settings-sub-account-settings-title")}
    </div>
  );
};

const Divider5 = () => {
  const { getTextByKey } = useContent();

  return (
    <div className="divider-wrapper">
      <div className="Divider-within-the-form">
        {getTextByKey("profile-settings-sign-up-title")}
      </div>
      <span>{getTextByKey("profile-settings-sign-up-subtitle")}</span>
    </div>
  );
};

const Divider6 = () => {
  const { getTextByKey } = useContent();

  return (
    <div className="divider-wrapper">
      <span>{getTextByKey("profile-settings-sign-up-hint")}</span>
    </div>
  );
};

export const NotificationFields = {
  CustomElement2: {
    fieldKey: "CustomElement2",
    element: "customelement",
    render: () => <Divider2 />,
  },
  UserReceiveDownloadNotification: {
    fieldKey: "UserReceiveDownloadNotification",
    element: "checkbox",
    title: "UserReceiveDownloadNotification",
    label: "profilesettings-download-notification",
    className: "general-settings",
    tooltip: {
      text: "profilesettings-download-notification-tooltip",
      icon: "question-circle",
    },
  },
  UserReceiveRecipientAlertDelete: {
    fieldKey: "UserReceiveRecipientAlertDelete",
    element: "checkbox",
    title: "UserReceiveRecipientAlertDelete",
    label: "profilesettings-recipient-alert-mails",
    className: "general-settings",
    tooltip: {
      text: "profilesettings-recipient-alert-mails-tooltip",
      icon: "question-circle",
    },
  },
  UserReceiveAlertBeforeDeletion: {
    fieldKey: "UserReceiveAlertBeforeDeletion",
    element: "checkbox",
    title: "UserReceiveAlertBeforeDeletion",
    label: "profilesettings-alert-before-deletion",
    className: "general-settings",
    tooltip: {
      text: "profilesettings-alert-before-deletion-tooltip",
      icon: "question-circle",
    },
  },
  ToBlock: {
    fieldKey: "ToBlock",
    element: "checkbox",
    title: "ToBlock",
    label: "profilesettings-download",
    className: "general-settings",
    tooltip: {
      text: "profilesettings-download-comment",
      icon: "question-circle",
    },
  },
  CustomElement3: {
    fieldKey: "CustomElement3",
    element: "customelement",
    render: () => <Divider3 />,
  },
  UserReceiveMailCopy: {
    fieldKey: "UserReceiveMailCopy",
    element: "checkbox",
    title: "UserReceiveMailCopy",
    label: "profilesettings-copy-notification",
    className: "general-settings",
    tooltip: {
      text: "profilesettings-copy-notification-tooltip",
      icon: "question-circle",
    },
  },
  UserReceiveMarketing: {
    fieldKey: "UserReceiveMarketing",
    element: "checkbox",
    title: "UserWantUpdates",
    label: "profilesettings-want-updates",
    className: "general-settings",
    tooltip: {
      text: "profilesettings-want-updates-comment",
      icon: "question-circle",
    },
  },
  UserPlaySounds: {
    fieldKey: "UserPlaySounds",
    element: "checkbox",
    title: "UserPlaySounds",
    label: "profilesettings-play-sounds",
    className: "general-settings",
    tooltip: {
      text: "profilesettings-play-sounds-comment",
      icon: "question-circle",
    },
  },
};

export const DynamicEmailInputField = (props) => {
  const { getTextByKey } = useContent();
  const receiveInvoices = props.getValues().ReceiveInvoices;
  const { getUserData } = useUser();
  const userName = getUserData()?.UserName;

  const { fieldControls, clearErrors } = useCustomController({
    ...props,
    cutomValidation: {
      checkDisableValidation: () => !receiveInvoices,
    },
  });

  useEffect(() => {
    if (!receiveInvoices) {
      clearErrors();
      props.setValue("InvoicesEmail", userName);
    }
  }, [receiveInvoices, userName]);

  useEffect(() => {
    fieldControls.onChange(userName);
  }, [userName]);

  return receiveInvoices ? (
    <label className="email-input-label">
      <input
        value={fieldControls.value}
        onChange={(e) => fieldControls.onChange(e.target.value)}
        className="email-input"
      />
      <div className="tooltip-container">
        <Tooltip tooltipText={getTextByKey("receive-invoices-tooltip")}>
          <Icon
            name="info"
            iconClass="info-icon"
            white
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          />
        </Tooltip>
      </div>
    </label>
  ) : null;
};

export const NotificationFieldsWithReceiveInvoices = {
  ...NotificationFields,
  ReceiveInvoices: {
    fieldKey: "ReceiveInvoices",
    element: "checkbox",
    title: "ReceiveInvoices",
    label: "profilesettings-receive-invoices",
    className: "general-settings",
    tooltip: {
      text: "profilesettings-receive-invoices-comment",
      icon: "question-circle",
    },
  },
  InvoicesEmail: {
    fieldKey: "InvoicesEmail",
    element: "customelement",
    validation: {
      required: true,
      reg: EMAIL_VALIDATOR,
      invalidMessage: "email-input-invalid-message",
    },
    render: (props) => <DynamicEmailInputField {...props} />,
  },
};

export const NotificationSubUserFields = {
  CustomElement4: {
    fieldKey: "CustomElement4",
    element: "customelement",
    render: () => <Divider4 props />,
  },
  SubUserSetBranding: {
    fieldKey: "SubUserSetBranding",
    element: "checkbox",
    title: "SubUserSetBranding",
    label: "myprofile-sub-user-management-set-branding",
    className: "general-settings",
    tooltip: {
      text: "myprofile-sub-user-management-set-branding-tooltip",
      icon: "question-circle",
    },
  },
  EnforceStrongPass: {
    fieldKey: "EnforceStrongPass",
    element: "checkbox",
    title: "EnforceStrongPass",
    label: "enforce-storng-pass",
    className: "general-settings",
    tooltip: {
      text: "enforce-storng-pass-tooltip",
      icon: "question-circle",
    },
  },
  HideJumboPay: {
    fieldKey: "HideJumboPay",
    element: "checkbox",
    title: "HideJumboPay",
    label: "hide-jumbo-pay-label",
    className: "general-settings",
    tooltip: {
      text: "hide-jumbo-pay-tooltip",
      icon: "question-circle",
    },
  },
  HideJumboPicker: {
    fieldKey: "HideJumboPicker",
    element: "checkbox",
    title: "HideJumboPicker",
    label: "hide-jumbo-picker-label",
    className: "general-settings",
    tooltip: {
      text: "hide-jumbo-picker-tooltip",
      icon: "question-circle",
    },
  },
  IsSubUserRestrictedToUsePrivateAccount: {
    fieldKey: "IsSubUserRestrictedToUsePrivateAccount",
    element: "checkbox",
    title: "IsSubUserRestrictedToUsePrivateAccount",
    label: "restrict-use-domain-for-private",
    className: "general-settings",
    tooltip: {
      text: "restrict-use-domain-for-private-tooltip",
      icon: "question-circle",
    },
  },
  AutoRemoveSettings: {
    fieldKey: "AutoRemoveSettings",
    title: "AutoRemoveAndDefaultSave",
    label: "profilesettings-AutoRemoveSettings",
    placeholder: "profileuserdetails-autoremovalandsdefaultave",
    element: "customelement",
    render: (props) => <CustomRadioButtonField {...props} />,
    containerClassName: "customRadioButton",
  },
  CustomElement5: {
    fieldKey: "CustomElement5",
    element: "customelement",
    render: () => <Divider5 props />,
  },
  Email: {
    fieldKey: "Email",
    element: "checkbox",
    title: "Email",
    label: "jumbomail-signup-checkbox",
    className: "general-settings",
    tooltip: {
      text: "jumbomail-signup-tooltip",
      icon: "question-circle",
    },
  },
  MicrosoftSSO: {
    fieldKey: "MicrosoftSSO",
    element: "checkbox",
    title: "MicrosoftSSO",
    label: "microsoft-signup-checkbox",
    className: "general-settings",
    tooltip: {
      text: "microsoft-signup-tooltip",
      icon: "question-circle",
    },
  },
  GoogleSSO: {
    fieldKey: "GoogleSSO",
    element: "checkbox",
    title: "GoogleSSO",
    label: "google-signup-checkbox",
    className: "general-settings",
    tooltip: {
      text: "google-signup-tooltip",
      icon: "question-circle",
    },
  },
  CustomElement6: {
    fieldKey: "CustomElement6",
    element: "customelement",
    render: () => <Divider6 props />,
  },
};
